import { render } from "./JobsList.vue?vue&type=template&id=e81b6632&scoped=true"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"

import "./JobsList.vue?vue&type=style&index=0&id=e81b6632&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81b6632"]])

export default __exports__